<template>
  <div>
    <PageTitle :route="$route">
      <template slot="action-button">
        <ActionButton icon="fa-sync-alt" @click="load" />
      </template>
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <TemperatureSensorDelayList />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from "@/components/layout/PageTitle";
import PageRowWrapper from "@/components/layout/PageRowWrapper";
import TemperatureSensorDelayList from "@/components/reports/temperaturesensordelay/TemperatureSensorDelayList";
import ActionButton from "@/components/button/ActionButton";

export default {
  name: "TemperatureSensorDelayLists",

  components: {
    PageTitle,
    PageRowWrapper,
    TemperatureSensorDelayList,
    ActionButton,
  },

  methods: {
    async load() {
      await this.$store.dispatch("temperaturesensordelay/fetchAll");
    },
  },

  async mounted() {
    await this.load();
  },

  destroyed() {
    this.$store.commit("temperaturesensordelay/cleanState");
  },
};
</script>
